module.exports = __webpack_public_path__ + "img/解决方案_能源_灰.e37a0c9d.svg";